import React from 'react';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { SignInEmptyDiv2 } from '../component/sign-in-empty/SignInEmptyDiv2';

export const SignInEmptyPage2 = () => (
  <SignInPageLayout centerDesktop={<SignInEmptyDiv2 />} />
);
